const storageKeys = {
  X_AUTH_TOKEN: 'x-auth-token',
  USER_DATA: '@PCS-UX/UserData',
  TRACEPARENT: 'traceparent',
  LANGUAGE: 'language'
};

export default storageKeys;
